import assetPath from '/app/packages/startpage-logged-out/native-apps-section/src/assets/app-store-badge-en.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')